import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { PageHeader, Card, Avatar, Loading } from "../components/ui";

function Node({ emp, all, depth = 0 }) {
  const reports = all.filter((e) => e.managerId === emp.id);
  return (
    <div className="ml-0">
      <Link to={`/employees/${emp.id}`} className="mb-2 flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-3 transition-colors hover:border-accent dark:border-slate-800 dark:bg-slate-900" data-testid={`org-node-${emp.employeeCode}`}>
        <Avatar name={emp.fullName} size={38} url={emp.profilePhotoUrl} />
        <div>
          <div className="text-sm font-semibold text-slate-800 dark:text-slate-100">{emp.fullName}</div>
          <div className="text-xs text-slate-400">{emp.designationName} · {emp.departmentName}</div>
        </div>
      </Link>
      {reports.length > 0 && (
        <div className="ml-6 border-l-2 border-slate-200 pl-5 dark:border-slate-800">
          {reports.map((r) => <Node key={r.id} emp={r} all={all} depth={depth + 1} />)}
        </div>
      )}
    </div>
  );
}

export default function OrgChart() {
  const [emps, setEmps] = useState(null);
  useEffect(() => { api.get("/employees/orgchart").then(({ data }) => setEmps(data)); }, []);
  if (!emps) return <Loading />;
  const roots = emps.filter((e) => !e.managerId);
  return (
    <div>
      <PageHeader title="Org Chart" subtitle="Reporting hierarchy across SMIFS" />
      <Card className="p-6">
        {roots.map((r) => <Node key={r.id} emp={r} all={emps} />)}
      </Card>
    </div>
  );
}
